class NotificationReducer {
  static ADD_NOTIFICATION = "ADD_NOTIFICATION";
  static REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";

  static addNotification = (text, type, linkText, linkURL) => {
    return {
      type: this.ADD_NOTIFICATION,
      payload: { text, type, linkText, linkURL },
    };
  };

  static remoevNotification = (notificationId) => {
    return {
      type: this.REMOVE_NOTIFICATION,
      payload: { notificationId },
    };
  };
}

export default NotificationReducer;
